export const region = [
  {
    province: "Gangwon",
    description:
      "The Taebaek Mountain Range and the East Sea are adjacent. Because you can come into contact with the products of the mountainous and coastal regions, a very diverse diet has been developed, and it is also called an area blessed with heavenly blessings. In addition to agricultural products such as acorns, corn, and potatoes, it is also famous for seafood such as squid and seaweed. Squid sundae and squid bulgogi are also starting to become famous in Gangwon-do.",
    food: ["Squid sundae", "Squid bulgogi"],
  },

  {
    province: "Seoul / Gyeonggi",
    description:
      "Due to the geographical characteristics of Seoul, there are not many products produced directly in the region, and various food ingredients are concentrated nationwideIt is characterized by colorful food. The amount of food is not much, but the number of food varies.",
    food: ["Seolleongtang", "Yukgaejang", "Galbi", "Gujeolpan"],
  },

  {
    province: "Chungcheong",
    description:
      "Chungcheong-do has developed mainly in agriculture, and grains such as rice and barley, cabbages and vegetables are well developed, and seafood dishes are also available in areas bordering the West Sea",
    food: ["Jjigae"],
  },

  {
    province: "Gyeongsang",
    description:
      "It is characterized by abundant seafood because it is located along the East and South Seas. In addition, crops are abundant in fertile farmland on the wide plain. In general, the liver is a little strong, spicy food is developed a lot, and it has a rough and simple taste rather than colorful or stylish.",
    food: ["Jeonbok-juk", "Agwi-jjim", "Chueo-tang"],
  },

  {
    province: "Jeolla / Gwangju",
    description:
      "Jeolla-do is an area where you can enjoy wild vegetables, fruits, and seafood, including agricultural products, because it is located along the West Sea and the South Sea. Jeonju and Gwangju are also famous for serving a variety of side dishes that are not easily found in other regions.",
    food: ["Bibimbap", "Kongnamul Guk", "Kimchi"],
  },
];
